import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../base';


/**
 * Component to handle pagination of table list.
 */
@Component({
	selector: 'tsp-pagination',
	imports: [
		FormsModule,
		NgbPaginationModule
	],
	templateUrl: './pagination.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PaginationComponent extends BaseComponent {

	readonly pageSizeList = [10, 20, 50];

	page = model(1);
	pageSize = model(this.pageSizeList[0]);
	collectionSize = input(1);

	totalPages = computed(() => this.pageSize() ? Math.ceil(this.collectionSize() / this.pageSize()) : 1);
}
